import React, { createContext, useState, ReactNode } from 'react';

interface AppContextModel {
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
  notifications: any[];
  setNotifications: (arg: any[]) => void;
  showNotificationBadge: boolean;
  setShowNotificationBadge: (arg: boolean) => void;
}

export const AppContext = createContext({} as AppContextModel);

interface Props {
  children?: ReactNode;
}

export const AppContextProvider: React.FC<Props> = ({ children }) => {
  const [navOpen, setNavOpen] = useState<boolean>(true);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [showNotificationBadge, setShowNotificationBadge] =
    useState<boolean>(false);

  const value = {
    navOpen,
    setNavOpen,
    notifications,
    setNotifications,
    showNotificationBadge,
    setShowNotificationBadge
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
